export const CasinosNew = ({ width = 14, height = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4120_38105)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8839 0.366117L10.7661 0.262131C10.2758 -0.11915 9.56672 -0.0844884 9.11612 0.366117L6.98 2.5H3.75L3.60422 2.50841C2.98255 2.58062 2.5 3.10896 2.5 3.75V6.98L0.366117 9.11612L0.262131 9.23388C-0.11915 9.72424 -0.0844884 10.4333 0.366117 10.8839L2.5 13.0188V16.25L2.50841 16.3958C2.58062 17.0175 3.10896 17.5 3.75 17.5H6.98125L9.11612 19.6339L9.23388 19.7379C9.72424 20.1192 10.4333 20.0845 10.8839 19.6339L13.0175 17.5H16.25L16.3958 17.4916C17.0175 17.4194 17.5 16.891 17.5 16.25V13.0175L19.6339 10.8839L19.7379 10.7661C20.1192 10.2758 20.0845 9.56672 19.6339 9.11612L17.5 6.98125V3.75L17.4916 3.60422C17.4194 2.98255 16.891 2.5 16.25 2.5H13.0188L10.8839 0.366117ZM7.70711 6.29289C7.42111 6.0069 6.99099 5.92134 6.61732 6.07612C6.24364 6.2309 6 6.59554 6 7V13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13V9.41421L12.2929 13.7071C12.5789 13.9931 13.009 14.0787 13.3827 13.9239C13.7564 13.7691 14 13.4045 14 13V7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7V10.5858L7.70711 6.29289Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4120_38105">
          <rect width="20" height="20" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
